import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiMail, FiPhone, FiMapPin, FiClock, FiShare2 } from "react-icons/fi";
import { FaWhatsapp, FaLinkedin, FaInstagram, FaFacebook } from "react-icons/fa";
import { submitForm } from "../utils/submitForm";
import { trackEvent } from "../utils/analytics";
import { company } from "../data/site";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const result = await submitForm(`Website enquiry: ${formData.subject}`, formData);
      if (result === "sent") trackEvent("generate_lead", { form_name: "contact" });
      setStatus(result);
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <section id="contact" className="section">
      <div className="container contact-content">
        <div className="contact-info">
          <a className="contact-item" href={`mailto:${company.email}`}>
            <span className="service-icon"><FiMail /></span>
            <div>
              <p className="contact-label">Email</p>
              <p>{company.email}</p>
            </div>
          </a>

          <div className="contact-item">
            <span className="service-icon"><FiPhone /></span>
            <div>
              <p className="contact-label">Phone</p>
              <p>
                {company.phones.map((phone, index) => (
                  <React.Fragment key={phone.href}>
                    {index > 0 && <br />}
                    <a href={phone.href}>{phone.display}</a>
                  </React.Fragment>
                ))}
              </p>
            </div>
          </div>

          <a className="contact-item" href={company.whatsapp} target="_blank" rel="noopener noreferrer">
            <span className="service-icon"><FaWhatsapp /></span>
            <div>
              <p className="contact-label">WhatsApp</p>
              <p>Chat with us directly</p>
            </div>
          </a>

          <a className="contact-item" href={company.mapUrl} target="_blank" rel="noopener noreferrer">
            <span className="service-icon"><FiMapPin /></span>
            <div>
              <p className="contact-label">Office</p>
              <p>{company.address}</p>
            </div>
          </a>

          <div className="contact-item">
            <span className="service-icon"><FiClock /></span>
            <div>
              <p className="contact-label">Hours</p>
              <p>{company.hours}</p>
            </div>
          </div>

          <div className="contact-item">
            <span className="service-icon"><FiShare2 /></span>
            <div>
              <p className="contact-label">Follow us</p>
              <div className="social-links contact-socials">
                <a href={company.socials.linkedin} target="_blank" rel="noopener noreferrer" aria-label="Fedigma on LinkedIn"><FaLinkedin /></a>
                <a href={company.socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Fedigma on Instagram"><FaInstagram /></a>
                <a href={company.socials.facebook} target="_blank" rel="noopener noreferrer" aria-label="Fedigma on Facebook"><FaFacebook /></a>
              </div>
            </div>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>Tell us about your project</h2>
          <p>We reply within one business day.</p>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Full name</label>
              <input
                type="text"
                id="name"
                name="name"
                autoComplete="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                id="email"
                name="email"
                autoComplete="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="subject">What do you need?</label>
            <input
              type="text"
              id="subject"
              name="subject"
              placeholder="e.g. School management system, new website"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Project details</label>
            <textarea
              id="message"
              name="message"
              placeholder="Goals, timeline, budget, anything that helps us understand"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="btn btn-lg" disabled={status === "sending"}>
            {status === "sending" ? "Sending..." : "Send message"}
          </button>
          <p className="form-note">
            By sending this form you agree to our <Link to="/privacy">privacy policy</Link>.
          </p>

          {status === "sent" && (
            <p className="form-status success" role="status">
              Thank you! Your message has been sent. We will get back to you soon.
            </p>
          )}
          {status === "mailto" && (
            <p className="form-status success" role="status">
              Your email app has opened with your message. Just hit send.
            </p>
          )}
          {status === "error" && (
            <p className="form-status error" role="alert">
              Something went wrong. Please email us at {company.email}.
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default Contact;
